import React from "react";

import {
  useSearchParams
} from "react-router-dom";
import {
  Content,
  Grid,
  GridItem,
  PageSection,
  Pagination,
  Stack,
  StackItem,
  Flex,
  FlexItem
} from "@patternfly/react-core";


import NewsPanel from "../../features/news/components/NewsPanel";
import NewsPageSkeleton from "../../features/news/components/NewsPageSkeleton";

import { useNewsData } from "../../features/news/hooks/useNewsData";

const PER_PAGE = 12;


const NewsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const page = Math.max(
    1,
    Number(searchParams.get("page")) || 1
    );
    
    const {
        news,
        loading,
        error,
        total
    } = useNewsData({
        page,
        perPage: PER_PAGE
    });
  
    const handlePageChange = (_event, newPage) => {
        setSearchParams({
            page: String(newPage)
        });

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const [isMobile, setIsMobile] = React.useState(
  () => window.matchMedia("(max-width: 767px)").matches
    );

    React.useEffect(() => {
      const mediaQuery = window.matchMedia("(max-width: 767px)");

      const handleChange = (event) => {
        setIsMobile(event.matches);
      };

      mediaQuery.addEventListener("change", handleChange);

      return () => {
        mediaQuery.removeEventListener("change", handleChange);
      };
    }, []);

    const pagination = (
      <Pagination
        itemCount={total}
        perPage={PER_PAGE}
        page={page}
        onSetPage={handlePageChange}
        variant="bottom"
      />
    );
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content style={{ textAlign: "center" }}>
                <h1>Aktualności</h1>

                <p>
                  Informacje, wydarzenia, sukcesy uczniów
                  i relacje z życia szkoły.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>


        {loading && (
        <StackItem>
            <NewsPageSkeleton />
        </StackItem>
        )}


        {error && (
          <StackItem>
            <Content style={{ textAlign: "center" }}>
              <p>
                Nie udało się pobrać aktualności.
              </p>
            </Content>
          </StackItem>
        )}

        {!loading && !error && total > PER_PAGE && (
          <StackItem>
            {isMobile ? (
              pagination
            ) : (
              <Flex justifyContent={{ default: "justifyContentCenter" }}>
                <FlexItem>
                  {pagination}
                </FlexItem>
              </Flex>
            )}
          </StackItem>
        )}

        {!loading && !error && news.length > 0 && (
          <StackItem>
            <NewsPanel
              news={news}
              showHeader={false}
              showAction={false}
            />
          </StackItem>
        )}

        {!loading && !error && total > PER_PAGE && (
          <StackItem>
            {isMobile ? (
              pagination
            ) : (
              <Flex justifyContent={{ default: "justifyContentCenter" }}>
                <FlexItem>
                  {pagination}
                </FlexItem>
              </Flex>
            )}
          </StackItem>
        )}
      </Stack>
    </PageSection>
  );
};


export default NewsPage;